// extracted by mini-css-extract-plugin
export default {"container":"MainSection_container__Kp6T6","fullWidth":"MainSection_fullWidth__Kae7D"};